export const ANIMATIONS_PAUSED_STORAGE_KEY = 'optiver-animations-paused';
try {
    const stored = sessionStorage.getItem(ANIMATIONS_PAUSED_STORAGE_KEY);
    if (stored === 'true') {
        document.documentElement.dataset.animationsPaused = 'true';
    }
}
catch {
    // sessionStorage may be unavailable in privacy modes
}
